import Route from "@ember/routing/route";

export default class LoadBalancersController extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }
}
